<template>
  <div
    class="tags"
    :class="`creative-item-${tagKey}`"
  >
    <div
      v-if="overflowing"
      class="d-inline"
    >
      <div
        v-for="(tag, tagIndex) in tagsArr"
        :key="tagIndex"
        class="d-inline"
      >
        <span
          v-if="tagIndex < index || index === -1"
          class="tag-item"
        >
          {{ tag }}
        </span>
      </div>
      <span
        @mouseover="onHover"
        @mouseleave="isNotOnHover"
      >
        <b-dropdown
          v-if="index != -1 && index < tagsArr.length"
          ref="tagDropdown"
          right
          class="tag-more-items"
          no-caret
          variant="link-secondary"
          size="sm"
        >
          <template #button-content>
            <span
              class="py-0 px-50"
            >
              <GjIcon
                name="Moreoptions"
                size="22"
              />
            </span>
          </template>
          <b-dropdown-item
            v-for="(tag, tagIndex) in tagsArr.slice(index)"
            :key="tagIndex"
          >
            <span
              class="overflow-answers"
            >
              {{ tag }}
            </span>
          </b-dropdown-item>
        </b-dropdown>
      </span>
    </div>
    <div v-else>
      <div
        v-for="(tag, tagIndex) in tagsArr"
        :key="tagIndex"
        class="d-inline tag-item"
      >
        {{ tag }}
      </div>
    </div>
  </div>
</template>

<script>
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import {
  ref, onMounted, watch, computed,
} from '@vue/composition-api'

export default {
  components: {
    GjIcon,
  },
  props: {
    tags: {
      type: [Array, Object],
    },
    tagKey: {
      type: [Number],
    },
  },
  setup(props, context) {
    const overflowing = ref(false)
    const tagsArr = computed(() => [...props.tags])
    const index = ref(-1)
    const isOnHover = ref(false)

    const isOverflow = () => {
      context.root.$nextTick(() => {
        const parent = document.querySelector(`.creative-item-${props.tagKey}`)
        const childs = document.querySelectorAll(`.creative-item-${props.tagKey} .tag-item`)
        const parentWidth = parent.offsetWidth
        let width = 0
        for (let i = 0; i < childs.length; i += 1) {
          width += childs[i].offsetWidth
          if (width > parentWidth - 80) {
            index.value = tagsArr.value.findIndex(x => x.replace(/\s+/g, '') === childs[i].innerText.replace(/\s+/g, ''))
            overflowing.value = true
            break
          }
        }
      })
    }
    onMounted(() => {
      isOverflow()
    })
    watch(tagsArr, () => {
      if (tagsArr.value.length > 0) {
        isOverflow()
      }
    })
    const onHover = () => {
      context.refs.tagDropdown.show()
    }
    const isNotOnHover = () => {
      context.refs.tagDropdown.hide()
    }
    return {
      overflowing,
      isOnHover,
      tagsArr,
      index,
      onHover,
      isNotOnHover,
    }
  },
}
</script>
<style lang="scss">
.tag-item{
    border: solid 1px #E0E5EB;
    color: #052D61;
    border-radius: 20px;
    padding: 4px 8px;
    margin-right: 4px;
    display: inline;
    font-size: 14px;
}
.overflow-answers{
  border: 1px #e0e5eb solid;
  border-radius: 20px;
  width: fit-content;
  padding: 4px 8px;
}
.tag-more-items{
  border: solid 1px #E0E5EB;
  border-radius: 20px !important;
  padding: 2px 0;
  span{ color: #052D61;}
  button.dropdown-toggle{
    padding: 0;
  }
  ul.dropdown-menu {
    padding: 4px;
    z-index: 1040 !important;
    min-width: 30px;
    li > a.dropdown-item {
      padding: 4px !important;
      height: 34px;
      cursor: default;
      &:hover {
        background-color: #fff !important;
      }
    }
  }
}
</style>
